import { GzRemediationActionWebComponent } from './component/GzRemediationActionWebComponent';

export { GzRemediationActionWebComponent };
